import { render } from "./existing-channel-selector-form.vue?vue&type=template&id=23967784&lang=pug"
import script from "./existing-channel-selector-form.vue?vue&type=script&lang=js"
export * from "./existing-channel-selector-form.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__